var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6621 9.95362C17.8293 9.65983 16.9333 9.5 16 9.5C11.5817 9.5 8 13.0817 8 17.5C8 21.9183 11.5817 25.5 16 25.5C20.4183 25.5 24 21.9183 24 17.5C24 15.3875 23.1812 13.4663 21.8437 12.0364L23.5607 10.5",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6621 9.95362C17.8293 9.65983 16.9333 9.5 16 9.5C11.5817 9.5 8 13.0817 8 17.5C8 21.9183 11.5817 25.5 16 25.5C20.4183 25.5 24 21.9183 24 17.5C24 15.3875 23.1812 13.4663 21.8437 12.0364",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.03882V7C13.5 6.44772 13.9477 6 14.5 6H17.5C18.0523 6 18.5 6.44772 18.5 7V7.0813",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18V14",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.711cd7177fe9dbe8000089c93e0a2b8b.svg";
export { ForwardRef as ReactComponent };